import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { ModalROV } from './ModalROV'
import { connectResource } from '../../common/utils/resource'

class ModalROVContainer extends Component {
  state = {
    reason: '',
    comps: [],
    tab: 'reason',
    loading: false,
    showConfirmsubmit: false,
    confirmationText: '',
    showCloseModal: [],
  }

  componentDidMount() {
    this.addComp()
  }

  addComp = _ => {
    const { comps, showCloseModal } = this.state
    comps.push({
      property_address: '',
      property_city: '',
      property_state: '',
      property_zip: '',
      sales_price: '',
      date_of_sale: '',
      heated_square_footage: '',
      actual_age: '',
      site_size: '',
      source_of_data: '',
      mls_id: '',
      additional_comments: '',
    })
    showCloseModal.push(false)
    this.setState({
      tab: `comp #${comps.length}`,
      comps,
    })
  }

  changeTab = tab => this.setState({ tab })

  onTextChange = ({ target: { value, name } }, compIdx) => {
    if (compIdx !== undefined) {
      const { comps } = this.state
      const temp = [...comps]
      temp[compIdx][name] = value
      this.setState({
        comps: temp,
      })
    } else {
      this.setState({ [name]: value })
    }
  }

  onSelect = (state, idx) => {
    const { comps } = this.state
    const temp = [...comps]
    temp[idx].property_state = state
    this.setState({ comps: temp })
  }

  onRemoveComp = idx => {
    const { comps, showCloseModal } = this.state
    const temp = [...comps]
    temp.splice(idx, 1)

    const showtemp = [...showCloseModal]
    showtemp.splice(idx, 1)

    const tab = temp.length ? `comp #${temp.length}` : 'reason'
    this.setState({
      comps: temp,
      tab,
      showCloseModal: showtemp,
    })
  }

  onSubmit = _ => {
    const {
      reason,
      comps,
    } = this.state
    const {
      rovRequest,
      order_id,
      submission_version,
      onHide,
      refreshOrder,
    } = this.props
    this.setState({ loading: true })
    const body = {
      reason,
      comps: comps.map(comp => {
        if (comp.property_state) {
          comp.property_state = comp.property_state.value.toLowerCase()
        }
        return comp
      }),
      order_id,
      submission_version,
    }
    rovRequest.create(body)
      .then(_ => this.setState({ loading: false }))
      .then(onHide)
      .then(refreshOrder)
  }

  onConfirmSubmit = _ => {
    const { comps } = this.state
    if (comps.length < 1) {
      const confirmationText = 'Are you sure you want to submit without comps ?'
      this.setState({
        showConfirmsubmit: true,
        confirmationText,
      })
    } else {
      const compMissingPropertyAddress = comps.find(comp => comp.property_address === '')
      if (compMissingPropertyAddress) {
        const confirmationText = 'You are missing comparable property information! Send anyway?'
        this.setState({
          showConfirmsubmit: true,
          confirmationText,
        })
      } else {
        this.onSubmit()
      }
    }
  }

  onHideSubmit = () => {
    this.setState({ showConfirmsubmit: false })
  }

  onCloseComp = (idx) => {
    const { showCloseModal } = this.state
    const showTem = [...showCloseModal]
    showTem.splice(idx, 1, true)
    this.setState({ showCloseModal: showTem })
  }

  onHideCompModal = (idx) => {
    const { showCloseModal } = this.state
    const showTem = [...showCloseModal]
    showTem.splice(idx, 1, false)

    this.setState({ showCloseModal: showTem })
  }

  render() {
    const {
      loading,
      tab,
      comps,
      reason,
      showCloseModal,
      confirmationText,
      showConfirmsubmit,
    } = this.state
    const { onHide } = this.props

    return <ModalROV
      addComp={this.addComp}
      onSelect={this.onSelect}
      onSubmit={this.onSubmit}
      changeTab={this.changeTab}
      onTextChange={this.onTextChange}
      onRemoveComp={this.onRemoveComp}
      loading={loading}
      onHide={onHide}
      tab={tab}
      comps={comps}
      reason={reason}
      onConfirmSubmit={this.onConfirmSubmit}
      onHideSubmit={this.onHideSubmit}
      onCloseComp={this.onCloseComp}
      onHideCompModal={this.onHideCompModal}
      showCloseModal={showCloseModal}
      confirmationText={confirmationText}
      showConfirmsubmit={showConfirmsubmit}
    />
  }
}

const mapStateToProps = _ => ({})
const mapDispatchToProps = _ => ({})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  connectResource({
    namespace: 'rovRequest',
    endpoint: 'order/rov',
    prefetch: false,
    apiVersion: 2,
  })
)(ModalROVContainer)
